import React from 'react';
import CycleReportShell from '../../components/cycleReport/CycleReportShell';
import { PURCHASE_LANES } from '../../utils/cycleReportHelper';

// Purchase cycle: REQ → PO → GRN → PI/NPI/IPI (+ PR/NPR returns) → Payment.
// Filters and canvas behavior all live in CycleReportShell — this file is
// just the configuration entrypoint.
const PurchaseCycleReport = () => (
  <CycleReportShell
    title="Purchase Cycle"
    lanes={PURCHASE_LANES}
    partyType="vendor"
    partyCollectionName="vendors"
    partyNameField="vendorName"
    defaultStaleAfterDays={30}
  />
);

export default PurchaseCycleReport;
